import { get } from 'lodash';

const getLocaleCookie = (rootState) =>
  get(rootState, 'config.service.common.authtkt.current_language_cookie', '');

export default getLocaleCookie;
